module.exports = __webpack_public_path__ + "images/button_watch_video.gif";